import PropTypes from 'prop-types';
import React from 'react';
import { fieldInputPropTypes } from 'redux-form';

import './CheckBox.scss';

const InputCheckbox = ({
  input, inputID, label, bemClass, hidden,
}) => {
  if (hidden) {
    return null;
  }
  return (
    <div className="row">
      <div className="col-12">
        <div className={`pretty p-svg p-curve ${bemClass}`}>
          <input
            type="checkbox"
            {...input}
            id={inputID}
            checked={input.value}
          />
          <div className="state p-success">
            <svg className="svg svg-icon" viewBox="0 0 20 20">
              <path
                d="M7.629,14.566c0.125,0.125,0.291,0.188,0.456,0.188c0.164,0,0.329-0.062,0.456-0.188l8.219-8.221c0.252-0.252,0.252-0.659,0-0.911c-0.252-0.252-0.659-0.252-0.911,0l-7.764,7.763L4.152,9.267c-0.252-0.251-0.66-0.251-0.911,0c-0.252,0.252-0.252,0.66,0,0.911L7.629,14.566z"
                style={{ stroke: 'white', fill: 'white' }}
              />
            </svg>
            <label
              htmlFor={inputID}
              className={`${bemClass}-label form-check-label text-truncate`}
            >
              {label}
            </label>
          </div>
        </div>
      </div>
    </div>
  );
};

InputCheckbox.propTypes = {
  input: PropTypes.shape(fieldInputPropTypes).isRequired,
  inputID: PropTypes.string,
  label: PropTypes.string,
  bemClass: PropTypes.string,
  hidden: PropTypes.bool,
};

InputCheckbox.defaultProps = {
  label: null,
  inputID: null,
  bemClass: 'rx-checkbox',
  hidden: false,
};

export default InputCheckbox;
